/* import __COLOCATED_TEMPLATE__ from './edit-project-title.hbs'; */
import { scheduleOnce } from '@ember/runloop';
import { computed } from '@ember/object';
import { oneWay } from '@ember/object/computed';
import Component from '@ember/component';
import { handleFormErrorOrModal } from 'sh-www/utils/handles-errors';

/** @module */
const EditProjectTitleModal = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {Ember.ComputedProperty} */
  title: oneWay('application.title'),

  /** @type {boolean} */
  submitting: false,

  /** @type {boolean} */
  dirty: false,

  /** @type {Ember.ComputedProperty} */
  disabled: computed('submitting', 'dirty', function() {
    return this.get('submitting') || !this.get('dirty');
  }),

  /** @type Ember.ComputedProperty */
  titleValidator: computed('title', function() {
    const title = this.get('title');

    if (!title) return 'Project title is a required field';
    if (title.length < 5) return 'Project title must be at least 5 characters long';
    if (title.length > 200) return 'Project title must be less than 200 characters long';
  }),

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.set('errors', { });
  },

  /** @inheritDoc */
  didInsertElement() {
    this._super(...arguments);

    scheduleOnce('afterRender', this, function() {
      document.getElementById('edit-project-title-input').focus();
    });
  },

  /** @inheritDoc */
  actions: {
    /**
     * @param {string} value
     */
    handleInput(value) {
      this.setProperties({ title: value, dirty: true, 'errors.title': undefined });
    },

    /**
     *
     */
    handleSubmit() {
      if (!this.get('submitting') && this._validate()) {
        this.set('submitting', true);

        this.get('save')(this.get('title')).catch((e) => {
          handleFormErrorOrModal(this, e, ['title']);
        }).finally(() => {
          this.set('submitting', false);
        });
      }
    },

    /**
     *
     */
    handleCancel() {
      this.get('cancel')();
    },
  },

  /**
   * @param {title} string
   * @returns {boolean}
   * @private
   */
  _validate() {
    const errors = { };
    const titleError = this.get('titleValidator');

    if (titleError) {
      errors.title = titleError;
    }

    this.set('errors', errors);
    return !titleError;
  },
});

export default EditProjectTitleModal;
